import { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { usePrevious } from 'react-use';

import { hydrateSelectedItemsAction, resetSelectedItemsAction } from '@air/redux-selected-items';

import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { loadPersistedSelections } from '~/store/selectedItems/persistenceMiddleware';
import { useWorkspaces } from '~/swr-hooks/workspaces/useWorkspaces';
import { getLastUsedWorkspace } from '~/utils/WorkspaceUtils';

export const SelectedItemsHydration = memo(() => {
  const dispatch = useDispatch();
  const { crossLocationSelectionEnabled } = useFeatureFlags();
  const { data: workspaces = [] } = useWorkspaces();
  const currentWorkspace = getLastUsedWorkspace(workspaces);
  const previousWorkspace = usePrevious(currentWorkspace);

  useEffect(() => {
    const hasWorkspaceChanged = previousWorkspace?.id !== currentWorkspace?.id && previousWorkspace !== undefined;

    if (hasWorkspaceChanged) {
      dispatch(resetSelectedItemsAction());
    } else if (crossLocationSelectionEnabled === true) {
      const persistedSelections = loadPersistedSelections();
      if (persistedSelections.length > 0) {
        dispatch(hydrateSelectedItemsAction({ selectedItems: persistedSelections }));
      }
    }
  }, [dispatch, crossLocationSelectionEnabled, currentWorkspace, previousWorkspace]);

  return null;
});

SelectedItemsHydration.displayName = 'SelectedItemsHydration';
